import React from 'react';
import { FaUser } from 'react-icons/fa';
import UserOptions from './UserOptions';
import $ from 'jquery';

const User = ({
  user,
  index,
  handleOption,
  isAdmin,
  numberOfAdmin,
  disabledOptions,
}) => {
  $('[data-toggle="tooltip"]').tooltip();

  return (
    <div className='card users-card'>
      <div className='card-users'>
        <div
          className='row w-100 m-0 p-0 align-items-center'
          style={{ minHeight: '3rem' }}
        >
          {/* Name */}
          <div className='col-4 m-0 p-2'>
            <p className='title'>{user.name}</p>
          </div>
          {/* Email */}
          <div className='col-6'>
            <p className='title'>{user.email}</p>
          </div>
          {/* Role */}
          <div className='col-2 m-0 p-0 d-flex flex-row align-items-center justify-content-between'>
            <p className='title'>
              {user.role === 'Basic' ? 'Viewer' : user.role}
            </p>
            {disabledOptions ? (
              <span
                className='badge'
                data-toggle='tooltip'
                data-original-title='My account'
              >
                <FaUser />
              </span>
            ) : (
              <UserOptions
                index={index}
                handleOption={(value) => handleOption(value, user)}
                isAdmin={isAdmin}
                numberOfAdmin={numberOfAdmin}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
